import React from "react";
import { makeStyles } from "@mui/styles";
import PrimaryLogo from "../static/epesiPrimary.png";
import DilLogo from "../static/mobitillLogoNew.png";
import {
  Grid,
  Typography,
  Box,
  TextField,
  Button,
  Link,
  Divider,
  IconButton,
  Container,
} from "@mui/material";
import {
  ArrowUpward as ArrowUpIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  LocationOn as LocationIcon,
} from "@mui/icons-material";
import Contact from "./Contact";
import Copyright from "../components/Copyright";

const useStyles = makeStyles((theme) => ({
  footer: {
    // backgroundColor: '#ffffff',
    backgroundColor: "#fafbfd",
    margin: 0,
    padding: theme.spacing(6, 4),
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    position: "relative",
    borderTop: "1px solid rgba(0,0,0,0.06)",
    boxShadow: "inset 0 10px 20px rgba(0,0,0,0.02)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(6, 3),
    },
  },
  sectionTitle: {
    fontSize: "20px",
    fontWeight: 700,
    marginBottom: theme.spacing(4),
    color: "#1a1a1a",
    position: "relative",
    letterSpacing: "0.5px",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: "-12px",
      left: 0,
      width: "50px",
      height: "4px",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "4px",
    },
  },
  quickLinksContainer: {
    "& ul": {
      listStyle: "none",
      padding: 0,
      margin: 0,
    },
    "& li": {
      marginBottom: theme.spacing(2.5),
      // textDecoration: 'none',
    },
  },
  footerLink: {
    color: "#555",
    textDecoration: "none",
    fontSize: "15px",
    fontWeight: 500,
    transition: "all 0.4s ease",
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    paddingLeft: theme.spacing(0.5),
    "&:before": {
      content: '""',
      position: "absolute",
      left: "-6px",
      height: "0",
      width: "3px",
      backgroundColor: theme.palette.primary.main,
      borderRadius: "4px",
      opacity: 0,
      transition: "all 0.3s ease",
    },
    "&:hover": {
      color: theme.palette.primary.main,
      textDecoration: "none",
      transform: "translateX(8px)",
      "&:before": {
        height: "15px",
        opacity: 1,
      },
    },
    "&:focus": {
      // outline: `2px solid ${theme.palette.primary.main}`,
      // outlineOffset: '4px',
      textDecoration: "underline",
    },
  },
  newsletterSection: {
    backgroundColor: "#fff",
    padding: theme.spacing(4),
    borderRadius: "16px",
    border: "none",
    boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
    marginBottom: theme.spacing(4),
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
    },
  },
  newsletterInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "12px",
      height: "48px",
      backgroundColor: "rgba(0,0,0,0.02)",
      transition: "all 0.3s ease",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.03)",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
        borderWidth: "2px",
      },
      "&.Mui-focused": {
        backgroundColor: "#fff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
      },
    },
  },
  newsletterButton: {
    borderRadius: "12px",
    padding: theme.spacing(1.5, 3),
    fontWeight: 600,
    textTransform: "none",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    height: "48px",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
      transform: "translateY(-2px)",
    },
  },
  poweredBySection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(4),
    padding: theme.spacing(4),
    backgroundColor: "#fff",
    borderRadius: "16px",
    border: "none",
    boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
    flexDirection: "row",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    overflow: "hidden", // Prevent overflow
    position: "relative",
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      gap: theme.spacing(3),
      padding: theme.spacing(3, 2),
    },
  },
  logo: {
    maxWidth: 110, // Reduced size to prevent overflow
    width: "100%",
    height: "auto",
    objectFit: "contain", // Ensure logo maintains aspect ratio
    transition: "all 0.4s ease",
    filter: "drop-shadow(0 2px 5px rgba(0,0,0,0.1))",
    "&:hover": {
      transform: "scale(1.05)", // Reduced scale to prevent overflow
      filter: "drop-shadow(0 5px 15px rgba(0,0,0,0.15))",
    },
  },
  poweredByText: {
    fontWeight: 600,
    color: "#444",
    fontSize: "18px",
    letterSpacing: "0.5px",
  },
  backToTop: {
    position: "absolute",
    top: theme.spacing(-6),
    right: theme.spacing(6),
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    width: "50px",
    height: "50px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      transform: "translateY(-4px)",
      boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
    },
    transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
    [theme.breakpoints.down("sm")]: {
      top: theme.spacing(-4),
      right: theme.spacing(3),
      width: "40px",
      height: "40px",
    },
  },
  contactInfo: {
    marginBottom: theme.spacing(3),
  },
  copyRight: {
    padding: theme.spacing(2, 0),
    backgroundColor: theme.palette.primary.main,
    // backgroundImage: 'linear-gradient(135deg, rgba(255,255,255,0.05) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.05) 50%, rgba(255,255,255,0.05) 75%, transparent 75%, transparent)',
    // backgroundSize: '20px 20px',
    alignItems: "center",
    color: "#ffffff",
    // marginTop: theme.spacing(6),
    boxShadow: "inset 0 10px 20px rgba(0,0,0,0.1)",
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(1.5),
    borderRadius: "12px",
    backgroundColor: "rgba(255,255,255,0.9)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: "white",
      transform: "translateX(5px)",
      boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
    },
  },
  contactIcon: {
    color: theme.palette.primary.main,
    backgroundColor: "rgba(0,0,0,0.03)",
    padding: theme.spacing(1),
    borderRadius: "8px",
    transition: "all 0.3s ease",
  },
  socialContainer: {
    marginTop: theme.spacing(3),
  },
}));

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const Main = () => {
  const classes = useStyles();

  const quickLinks = [
    { title: "About Us", href: "/about" },
    { title: "How It Works", href: "/how-it-works" },
    { title: "Bus Operators", href: "/operators" },
    { title: "Support Center", href: "/support" },
    // { title: "Contact Us", href: "/contact" },
  ];

  const legalLinks = [
    { title: "Terms of Service", href: "/terms" },
    { title: "Privacy Policy", href: "/privacy" },
    { title: "Cookie Policy", href: "/cookies" },
    { title: "Refund Policy", href: "/refunds" },
    // { title: "Accessibility", href: "/accessibility" },
  ];

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Newsletter subscription logic would go here
    console.log("Newsletter subscription submitted");
  };

  return (
    <footer>
      <div className={classes.footer}>
        {/* <IconButton 
					className={classes.backToTop} 
					onClick={scrollToTop}
					aria-label="Back to top"
				>
					<ArrowUpIcon />
				</IconButton> */}

        <Container maxWidth="lg">
          <Grid container spacing={6}>
            {/* Contact Section */}
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography component="h3" className={classes.sectionTitle}>
                Get in Touch
              </Typography>
              <Box
                sx={{
                  mt: 1,
                  backgroundColor: "rgba(255,255,255,0.7)",
                  borderRadius: "16px",
                  p: 2,
                }}
              >
                <Contact isAddressVisible={true} isSocialMediaVisible={true} />
              </Box>
            </Grid>

            {/* Quick Links */}
            <Grid item xs={12} md={6} lg={2}>
              <Typography component="h3" className={classes.sectionTitle}>
                Quick Links
              </Typography>
              <Box className={classes.quickLinksContainer} sx={{ mt: 3 }}>
                <ul>
                  {quickLinks.map((link, index) => (
                    <li key={index}>
                      <Link
                        href={link.href}
                        className={classes.footerLink}
                        aria-label={link.title}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Box>
            </Grid>

            {/* Legal Links */}
            <Grid item xs={12} md={6} lg={2}>
              <Typography component="h3" className={classes.sectionTitle}>
                Legal
              </Typography>
              <Box className={classes.quickLinksContainer} sx={{ mt: 3 }}>
                <ul>
                  {legalLinks.map((link, index) => (
                    <li key={index}>
                      <Link
                        href={link.href}
                        className={classes.footerLink}
                        aria-label={link.title}
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        {link.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </Box>
            </Grid>

            {/* Newsletter & Powered By */}
            <Grid item xs={12} lg={4}>
              <Typography component="h3" className={classes.sectionTitle}>
                Stay Updated
              </Typography>

              {/* Newsletter Signup */}
              <Box className={classes.newsletterSection} sx={{ mt: 3 }}>
                <Typography
                  variant="body1"
                  sx={{ mb: 3, color: "#555", fontWeight: 500 }}
                >
                  Get the latest updates on routes, offers, and travel tips.
                </Typography>
                <Box
                  component="form"
                  onSubmit={handleNewsletterSubmit}
                  sx={{ display: "flex", gap: 1.5 }}
                >
                  <TextField
                    placeholder="Enter your email"
                    type="email"
                    required
                    className={classes.newsletterInput}
                    sx={{ flex: 1 }}
                    inputProps={{
                      "aria-label": "Email address for newsletter",
                    }}
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    className={classes.newsletterButton}
                    aria-label="Subscribe to newsletter"
                  >
                    Subscribe
                  </Button>
                </Box>
              </Box>

              {/* Powered By Section */}
              <Box className={classes.poweredBySection}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    flexWrap: "nowrap",
                  }}
                >
                  <Box
                    component="img"
                    src={PrimaryLogo}
                    alt="Epesi Logo"
                    className={classes.logo}
                    sx={{ filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))" }}
                  />
                  <Typography className={classes.poweredByText} sx={{ mx: 2 }}>
                    Powered By
                  </Typography>
                  <Box
                    component="img"
                    src={DilLogo}
                    alt="Mobitill Logo"
                    className={classes.logo}
                    sx={{ filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.1))" }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 5, opacity: 0.1 }} />
        </Container>
      </div>

      <Box className={classes.copyRight}>
        <Container maxWidth="lg">
          <Copyright />
        </Container>
      </Box>
      {/* <div className={classes.copyRight}>
				<Container maxWidth="lg">
					<Copyright />
				</Container>
			</div> */}
    </footer>
  );
};
export default Main;
